/**
 * @name maskEmail
 * @public
 * @description Masks an email address for privacy/security display purposes.
 * Keeps the first character of the username visible, masks all other characters
 * before the @ symbol with asterisks, and keeps the domain portion visible.
 * Example: 'user@example.com' becomes 'u****@example.com'
 *
 * @param {string} [email=''] - The email address to mask
 * @returns {string} The masked email address, or empty string if no email provided
 */
export default function maskEmail(email = '') {
  let mask = '';

  if (email) {
    const splitEmail = email.split('@');
    const [emailUsername] = splitEmail;

    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < emailUsername.length; i++) {
      mask += '*';
    }

    mask += '@';
    return emailUsername[0] + mask + splitEmail[1];
  }

  return mask;
}
